<div class="container">
  <div class="row">
    <div class="col">
      <div class="options d-flex flex-column align-items-center justify-content-center">
        <div  class="options-block d-flex align-items-center  mt-3">
          <button class="btn btn-outline-info text-dark" routerLink="/public/landing-page">  <i class="bi bi-arrow-left-short"> </i> {{'buttons.back' | translate}} </button>
          <div class="title">
            <h5 class="options-title">{{translatePath+'title' | translate}}</h5>
          </div>
        </div>

        <div class="options-container d-flex flex-column justify-content-between align-items-center mt-5">

          <div class="options-container__item">
            <img class="options-container__item--img" src="./../../../assets/images/about-delivery/line.svg">
            <div>
              <p class="options-container__item--description">{{translatePath+'option1' | translate}}</p>
            </div>
          </div>

          <div class="options-container__item">
            <img class="options-container__item--img" src="./../../../assets/images/delivery-options/delivery-international.svg">
            <div>
              <p class="options-container__item--description">{{translatePath+'option2' | translate}}</p>
            </div>
          </div>

          <div class="options-container__item">
            <img class="options-container__item--img" src="./../../../assets/images/delivery-options/door-door-to.svg">
            <div>
              <p class="options-container__item--description">{{translatePath+'option3' |translate}}</p>
            </div>
          </div>

          <div class="options-container__item">
            <img class="options-container__item--img" src="./../../../assets/images/delivery-options/pick-up-options.svg">
            <div>
              <p class="options-container__item--description">{{translatePath+'option4' | translate}}</p>
            </div>
          </div>



        </div>

        <div class="container container-description d-flex mt-5 mb-5 pb-3 justify-content-center">
          <div class="container-description__box d-flex">
            <div class="d-flex pb-3">

              <div>
                <div class="options-container__description--icon d-flex justify-content-center align-items-center">
                  <span class="text-white">!</span>
                </div>
              </div>
              <p class="container-description__box--about ml-3 ">{{translatePath+'data' | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
